"use client";

import { useQuery } from "@tanstack/react-query";
import { workspaceAppsApi } from "../api";
import { workspaceAppsKeys } from "../queryKeys";

export function useWorkspacePresetsQuery(workspaceUuid: string, enabled = true) {
  return useQuery({
    queryKey: workspaceAppsKeys.presets(workspaceUuid),
    queryFn: () => workspaceAppsApi.listPresets(workspaceUuid),
    enabled: enabled && workspaceUuid !== "",
  });
}

export function useWorkspacePresetInstallationsQuery(workspaceUuid: string) {
  return useQuery({
    queryKey: workspaceAppsKeys.installations(workspaceUuid),
    queryFn: () => workspaceAppsApi.listPresetInstallations(workspaceUuid),
    enabled: workspaceUuid !== "",
  });
}
